module.exports = __webpack_public_path__ + "static/media/28.c54ab797.jpg";